var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "0 0 161 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161 80.5C161 124.959 124.959 161 80.5 161C36.0411 161 0 124.959 0 80.5C0 36.0411 36.0411 0 80.5 0C124.959 0 161 36.0411 161 80.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.11 125.39L35.226 110.784C39.514 105.781 44.1147 100.734 49.028 95.642C53.9413 90.4607 58.9887 85.324 64.17 80.232C57.9167 74.7827 52.0653 69.914 46.616 65.626C41.256 61.2487 37.102 58.1667 34.154 56.38L47.554 38.692C52.378 42.176 57.604 46.1513 63.232 50.618C68.86 55.0847 74.5327 59.8193 80.25 64.822C85.5207 59.998 90.702 55.308 95.794 50.752C100.886 46.1067 105.755 41.7293 110.4 37.62L125.944 53.7C123.085 55.7547 119.021 59.1493 113.75 63.884C108.479 68.5293 102.762 73.7107 96.598 79.428C102.494 84.788 108.033 90.1033 113.214 95.374C118.485 100.555 123.13 105.379 127.15 109.846L110.802 124.72C109.194 122.755 106.871 120.209 103.834 117.082C100.797 113.955 97.268 110.471 93.248 106.63C89.3173 102.789 85.1187 98.858 80.652 94.838C76.364 99.0367 72.2993 103.101 68.458 107.032C64.706 110.963 61.4007 114.491 58.542 117.618C55.6833 120.834 53.5393 123.425 52.11 125.39Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.cb9bfc45e57fa748de82afb92ebf4e72.svg";
export { ForwardRef as ReactComponent };